import { Component, OnInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { DataFieldComponentBase } from './datafield-base-component';
import { JsonHttpService } from '../http/json-http.service';
import { LoadingPanelService } from '../loading-panel/loading-panel.service';
import { GenericModalService } from '../generic-modal/generic-modal.service';
import { BackupFileDownloaderService } from '../download/backup-file-downloader.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'ep-datafield-file-upload',
    templateUrl: './datafield-file-upload.component.html',
    inputs: ['isAlwaysEditable', 'datafield', 'formValidationGroup'],
    outputs: ['valueChanged'] // It's necessary to set this, because the valueChanged method is placed in the base-class and not inherited if this is not set.
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})

export class DataFieldFileUploadComponent extends DataFieldComponentBase implements OnInit, OnChanges {

    constructor(
        private jsonHttpService: JsonHttpService,
        private backupFileDownloaderService: BackupFileDownloaderService,
        private loadingPanelService: LoadingPanelService,
        private modalService: GenericModalService
    ) {
        super();
    }

    // Inherited properties - because of the lack of decorator-inheritance
    //@Input() public isAlwaysEditable: boolean;
    //@Input() public datafield: DataField;

    filename: string;

    override ngOnInit() {
    }

    override ngOnChanges(changes: any) {
        if (changes.datafield && this.datafield) {
            this.findFilename();
        }
    }

    findFilename() {
        if (this.datafield.Value) {
            this.filename = 'Searching for filename...';
            this.backupFileDownloaderService.getMiscFilename(this.datafield.Value).then(filename => {
                this.filename = filename || 'File not found...';
            });
        }
    }

    download() {
        this.loadingPanelService.showLoadingPanelDirect('Downloading file...');
        this.backupFileDownloaderService.downloadMiscFile(this.datafield.Value).then(() => {
            this.loadingPanelService.hideLoadingPanel();
        });
    }

    upload() {
        this.jsonHttpService.get('api/upload/get-max-file-size').toPromise().then(maxUploadSize => {
            this.modalService.fileSelectorDirect('Upload File', 'Select file to upload', false, undefined, undefined, undefined, undefined, maxUploadSize).then((files) => {
                this.loadingPanelService.showLoadingPanelDirect('Uploading file...');
                this.backupFileDownloaderService.uploadMiscFile(files[0], 'DataField', this.datafield.Value).then(fileIdentifier => {
                    this.datafield.Value = fileIdentifier;
                    this.filename = files[0].name;
                    this.loadingPanelService.hideLoadingPanel();
                });
            }, () => { })
        });
    }

    clear() {
        this.modalService.confirmDirect('Remove file', 'Remove the file?').then(() => {
            this.datafield.Value = null;
            this.filename = '';
        }).catch(() => { });
    }
}
